import {
  activeFeedbackTabSelector,
  feedbacksSelector,
  isPaperCheckInProgressSelector,
  sentenceOffsetsSelector,
  totalFeedbackCountSelector,
} from '@chegg-wt/core-wa/state/selectors'
import {
  setActiveFeedbackCardId,
  setActiveFeedbackTab,
} from '@chegg-wt/core-wa/state/actions'
import { useDispatch, useSelector } from 'react-redux'
import { calculateFeedbackPercentage } from '@chegg-wt/core-wa/utils/feedback'
import { colors } from '@chegg-ui/theme'
import { FeedbackTab } from '@chegg-wt/core-wa/constants/paraphraser'
import ProgressBar from './ProgressBar'
import { ProofReaderCardsContainer } from './styled'
import SuggestionTabs from './SuggestionTabs'
import EmptySuggestionsCard from './EmptySuggestionsCard'
import {
  ShimmerFeedbackCards,
  ShimmerProgressBar,
  ShimmerSuggestionTabs,
  TOTAL_CARDS_IN_SHIMMER,
} from './ShimmerCard'

const CardsContainer = () => {
  const sentenceOffsets = useSelector(sentenceOffsetsSelector)
  const feedbacks = useSelector(feedbacksSelector)
  const activeFeedbackTab = useSelector(activeFeedbackTabSelector)
  const isPaperCheckInProgress = useSelector(isPaperCheckInProgressSelector)
  const totalFeedbackCount = useSelector(totalFeedbackCountSelector)
  const dispatch = useDispatch()
  const setActiveTab = (tabIndex: number) => {
    dispatch(setActiveFeedbackTab(tabIndex))
    // On changing active feedback tab reset the active feedback card to first card
    dispatch(setActiveFeedbackCardId(null))
  }

  const isDraft = useSelector(sentenceOffsetsSelector).length === 0
  const totalFeedbacksCount = feedbacks.length

  return (
    <ProofReaderCardsContainer
      hasGreyBg={!isPaperCheckInProgress && totalFeedbacksCount === 0}
    >
      {/* case 1 : ProgressBar not acivated */}
      {!isDraft ? (
        <ProgressBar
          heading="Your Review:"
          progressBarColor={colors.cheggOrange}
          defaultColor={colors.grey100}
          progressBarPercentage={calculateFeedbackPercentage(
            totalFeedbacksCount,
            totalFeedbackCount,
            isPaperCheckInProgress
          )}
        />
      ) : (
        isPaperCheckInProgress && <ShimmerProgressBar />
      )}

      {/* case 2: ProgressBar acitvated */}
      {/* <ProgressBar
        heading=" Your Review: "
        subHeading="This piece on sustainability is well written, but a few small updates will make it shine."
        progressBarColor="#5B3CD0"
        defaultColor="#EEEEF1"
        progressBarPercentage={70}
      /> */}
      {totalFeedbacksCount === 0 && isPaperCheckInProgress && (
        <>
          <ShimmerSuggestionTabs />
          <ShimmerFeedbackCards
            hasOpenCard={totalFeedbacksCount === 0}
            noOfCards={TOTAL_CARDS_IN_SHIMMER}
          />
        </>
      )}
      {totalFeedbacksCount > 0 && (
        <SuggestionTabs
          feedbacks={feedbacks}
          sentenceOffsets={sentenceOffsets}
          activeTab={activeFeedbackTab}
          setActiveTab={setActiveTab}
        />
      )}
      {/* initial state when no paper checked or in progress */}
      {!isPaperCheckInProgress && totalFeedbacksCount === 0 && (
        <>
          <SuggestionTabs
            feedbacks={feedbacks}
            sentenceOffsets={sentenceOffsets}
            activeTab={activeFeedbackTab}
            setActiveTab={setActiveTab}
          />
          {(activeFeedbackTab === FeedbackTab.NO_ACTIVE_TAB || isDraft) && (
            <EmptySuggestionsCard />
          )}
        </>
      )}
    </ProofReaderCardsContainer>
  )
}

export default CardsContainer
